import { MODAL_ROUTE } from '@/constants';
import { useGetUnitsQuery } from '@/features/slice/products/unit/unit-api-slice';
import { useModal, useUrlFilter, useUrlPagination } from '@/hooks';

export const useUnitList = () => {
    const { debouncedSearchText, sortBy, sortOrder } = useUrlFilter();
    const { page, limit } = useUrlPagination();
    const { openModal } = useModal();

    const { data, isLoading, isFetching, isError, error } = useGetUnitsQuery({
        page,
        limit,
        search: debouncedSearchText,
        sort_by: sortBy,
        sort_order: sortOrder,
    });

    const handleCreateUnit = () => {
        openModal(MODAL_ROUTE.CREATE_PRODUCT_UNIT);
    };

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,

        handleCreateUnit,
    };
};
